/**
 * Money helpers. Backend stores everything in fils (minor units of AED).
 * Never trust or send prices from the browser — display only.
 */
export function formatMoney(money) {
  if (!money || typeof money.amount_minor !== "number") return "";
  const currency = money.currency || "AED";
  const value = money.amount_minor / 100;
  try {
    return new Intl.NumberFormat("en-AE", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${currency} ${value.toFixed(2)}`;
  }
}

export function taxNote(taxInclusive, vatRate) {
  const pct = Math.round((vatRate || 0) * 100);
  return taxInclusive ? `VAT (${pct}%) included` : `+ ${pct}% VAT`;
}
